import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { Dropdown, RecordSchedulerPanel, PrimaryButton, Input } from "@myplay/ui";

import { toTitleCase, capitalize } from '../../utils/stringManipulations';
import { NAME } from '../../utils/constants';
import I18N from '../../I18N';
import { WHITE, ORANGE, ORANGE_LIGHT } from '../../styles/colors';
import closeIcon from '../../assets/icons/Icon-Close.svg';
import ScheduleSuccess from './ScheduleSuccess';
import './ScheduleRecord.scss';

const ScheduleRecord = ({ TeamsStore, onClose, SitesStore })=> {
  const { teams } = TeamsStore;
  const [ selectedTeam, setSelectedTeam ] = useState(null); 
  const [ date, setDate ] = useState(null);
  const [ time, setTime ] = useState(null);
  const [ duration, setDuration ] = useState(null);
  const [ isValid, setIsValid ] = useState(false);
  const [ errorMessage, setErrorMessage ] = useState("");
  const [ shouldDisplaySuccessScreen, setSuccessScreenFlag ] = useState(false);
  const [ title, setTitle ] = useState(null);

  useEffect(()=> {
    if(!date || !time || !duration || !selectedTeam) {
      setIsValid(false);
      return ;
    };
    setIsValid(true);
  }, [ date, time, duration, selectedTeam ])

  const handleTeamSelect = team => {
    setSelectedTeam({ ...team });
  }

  const handleDatePick = date => {
    if (errorMessage) {
      setErrorMessage("");
    };
    setDate(date);
  };

  const handleTimePick = time => {
    if (errorMessage) {
      setErrorMessage("");
    };
    setTime(time);
  };

  const handleDurationPick = duration => {
    setDuration(duration);
  };

  const handleSave = async ()=> {
    try {
      const parsedDateTime = `${date} ${time}`;
      const dateTime = new Date(parsedDateTime);
      if (Date.parse(dateTime) <= Date.now()){
        setErrorMessage(capitalize(I18N.t("INVALID_DATE")));
        return ;
      }
      var isoDateTime = new Date(dateTime.getTime() - (dateTime.getTimezoneOffset() * 60000)).toISOString();
  
      const params = {
        team: selectedTeam,
        date: isoDateTime, 
        duration, 
        title
      };
  
      const isSaved = await SitesStore.scheduleRecord(params);
      setSuccessScreenFlag(isSaved);
    } catch (error) {
      console.log(error);
    }
  };

  const handleScheduleMore = ()=> {
    setSelectedTeam(null);
    setDate(null);
    setTime(null);
    setDuration(null);
    setTitle(null)
    setSuccessScreenFlag(false);
  };

  const handleTitleChange = event => {
    setTitle(event.target.value);
  }

  return (
    <div className="schedule-record" data-testid="schedule-record">
      {shouldDisplaySuccessScreen ?
        <ScheduleSuccess onClose={onClose} onScheduleMore={handleScheduleMore} /> :
        <Fragment>
          <button className="schedule-record__close-button" type="button" onClick={onClose}>
            <img src={closeIcon} alt=""/>
          </button>
          <Dropdown 
            placeholder={toTitleCase(I18N.t("CHOOSE_TEAM"))} 
            items={teams} 
            displayedProperty={NAME}
            onSelect={handleTeamSelect}
          />
          <div style={{ width: "80%" }}>
            <Input placeholder={capitalize(I18N.t("ADD_TITLE"))} onChange={event => handleTitleChange(event)}/>
            <RecordSchedulerPanel 
              onDatePick={handleDatePick}
              onTimePick={handleTimePick}
              onDurationPick={handleDurationPick}
            />
          </div>
          <span className="schedule-record__error">{errorMessage}</span>
          <div className="schedule-record__buttons-container">
            <PrimaryButton 
              color={WHITE} 
              background="transparent" 
              showBorder 
              onClick={onClose}
            >
              {I18N.t("DISCARD").toUpperCase()}
            </PrimaryButton>
            <PrimaryButton 
              color={WHITE} 
              background={isValid ? ORANGE : ORANGE_LIGHT} 
              onClick={isValid ? handleSave : null}
            >
              {I18N.t("SAVE").toUpperCase()}
            </PrimaryButton>
          </div>
        </Fragment>
      }
    </div>
  );
};

ScheduleRecord.propTypes = {
  onClose: PropTypes.func, 
  SitesStore: PropTypes.object, 
  TeamsStore: PropTypes.object 
};

ScheduleRecord.defaultProps = {
  onClose: ()=> {}, 
  SitesStore: {}, 
  TeamsStore: {} 
};

export default inject("TeamsStore", "SitesStore")(observer(ScheduleRecord));